/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { AppliedFiltersBar } from "~/components/AppliedFilters/AppliedFiltersBar";
import { UseAppliedFiltersResult } from "~/hooks/useAppliedFilters";

type Props<TKey extends string> = {
  state: UseAppliedFiltersResult<TKey>;
};

export function AppliedFiltersSection<TKey extends string>({
  state,
}: Props<TKey>) {
  return (
    <AppliedFiltersBar
      filters={state.filters}
      onRemoveFilter={state.onRemoveFilter}
      onRemoveFilterValue={state.onRemoveFilterValue}
      onClearAllFilters={state.onClearAllFilters}
    />
  );
}
